export const environment = {
  production: true,
  local: false,
};
